export const shippingDataObject = {
  currentShippingAddress: {
    City: 'Orem',
    CountryCode: 'US',
    CountryCodeDesc: null,
    District: '',
    DistrictDesc: null,
    InternationalAddresses: null,
    PostalCode: '84057-2061',
    Region: 'UT',
    RegionDesc: null,
    Street1: '1755 N State St',
    Street2: ''
  },
  currentShippingAddressName: 'Baltimore Catalyte mc',
  frequency: 1,
  nextDeliveryDate: 11529820000000,
  orderId: '951483741',
  shipToEmail: 'test@test.com',
  shipToPhone: '1233454321',
  shipping: {
    shipping: {
      ShippingMethod: {
        Code: 'EC',
        Cost: 0,
        Currency: null,
        Default: null,
        Description: 'Standard',
        PickUpLocation: ''
      },
      ShippingParty: [
        {
          'ShippingMemberID': 'US00973959',
          'Type': 'SOLD_TO',
          'ShippingAddress': {
            'ID': 'US00973959',
            'Name': 'LIU, JIAN',
            'CareOfName': '',
            'Address': {
              'Street1': '90 Knightsbridge Rd',
              'Street2': 'Apt 4N',
              'City': 'Great Neck',
              'District': '',
              'DistrictDesc': null,
              'Region': 'NY',
              'RegionDesc': null,
              'PostalCode': '11021-4531',
              'CountryCode': 'US',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [
              {
                'Country': '',
                'Value': {
                  'value': 'cindyma.zhangdan@gmail.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'HOMEPHONE'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'MOBILEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [
            {
              'Key': 'NAME_GIVEN',
              'Value': 'JIAN',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'LIU',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'USNY1102145310',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'US00973959',
          'Type': 'SHIP_TO',
          'ShippingAddress': {
            'ID': 'US00973959',
            'Name': 'JIAN LIU',
            'CareOfName': '',
            'Address': {
              'Street1': '90 Knightsbridge Rd',
              'Street2': 'Apt 4N',
              'City': 'Great Neck',
              'District': '',
              'DistrictDesc': null,
              'Region': 'NY',
              'RegionDesc': null,
              'PostalCode': '11021-4531',
              'CountryCode': 'US',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [
              {
                'Country': '',
                'Value': {
                  'value': 'cindyma.zhangdan@gmail.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'HOMEPHONE'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'MOBILEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [
            {
              'Key': 'NAME_GIVEN',
              'Value': '',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'JIAN LIU',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'USNY1102145310',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'US00973959',
          'Type': 'BILL_TO',
          'ShippingAddress': {
            'ID': 'US00973959',
            'Name': 'LIU, JIAN',
            'CareOfName': '',
            'Address': {
              'Street1': '90 Knightsbridge Rd',
              'Street2': 'Apt 4N',
              'City': 'Great Neck',
              'District': '',
              'DistrictDesc': null,
              'Region': 'NY',
              'RegionDesc': null,
              'PostalCode': '11021-4531',
              'CountryCode': 'US',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [
              {
                'Country': '',
                'Value': {
                  'value': 'cindyma.zhangdan@gmail.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'HOMEPHONE'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'MOBILEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [
            {
              'Key': 'NAME_GIVEN',
              'Value': 'JIAN',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'LIU',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'USNY1102145310',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'US00973959',
          'Type': 'PAYER',
          'ShippingAddress': {
            'ID': 'US00973959',
            'Name': 'LIU, JIAN',
            'CareOfName': '',
            'Address': {
              'Street1': '90 Knightsbridge Rd',
              'Street2': 'Apt 4N',
              'City': 'Great Neck',
              'District': '',
              'DistrictDesc': null,
              'Region': 'NY',
              'RegionDesc': null,
              'PostalCode': '11021-4531',
              'CountryCode': 'US',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [
              {
                'Country': '',
                'Value': {
                  'value': 'cindyma.zhangdan@gmail.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'HOMEPHONE'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'MOBILEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [
            {
              'Key': 'NAME_GIVEN',
              'Value': 'JIAN',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'LIU',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'USNY1102145310',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'US00927559',
          'Type': 'SPONSOR',
          'ShippingAddress': {
            'ID': 'US00927559',
            'Name': 'JIN, XI',
            'CareOfName': '',
            'Address': {
              'Street1': '90 Knightsbridge Rd',
              'Street2': 'Apt 4N',
              'City': 'Great Neck',
              'District': '',
              'DistrictDesc': null,
              'Region': 'NY',
              'RegionDesc': null,
              'PostalCode': '11021-4531',
              'CountryCode': 'US',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [
              {
                'Country': '',
                'Value': {
                  'value': 'jinxi2006@aol.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '571-344-3329',
                  'Type': 'HOMEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [
            {
              'Key': 'NAME_GIVEN',
              'Value': 'XI',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'JIN',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'USNY1102145310',
              'Type': 'PARTNER'
            }
          ]
        }
      ]
    },
    shippingMethods: {}
  },
  shippingAvailableMethods: [
    {
      'Code': 'EO',
      'Default': null,
      'Description': 'One Day Air',
      'Cost': 35,
      'PickUpLocation': '',
      'Currency': null
    },
    {
      'Code': 'EP',
      'Default': null,
      'Description': 'Express',
      'Cost': 12,
      'PickUpLocation': '',
      'Currency': null
    },
    {
      'Code': 'PS',
      'Default': null,
      'Description': 'USPS - US Mail',
      'Cost': 8,
      'PickUpLocation': '',
      'Currency': null
    },
    {
      'Code': 'EC',
      'Default': null,
      'Description': 'Standard',
      'Cost': 8,
      'PickUpLocation': '',
      'Currency': null
    }
  ],
  shippingId: 'US00320640',
  shippingMethodDetails: undefined,
  timeStamp: '20180626200738'

};
